// PlanComponents/RecommendedHiresCard.js
import React from 'react';
import { Typography, Table, TableBody, TableRow, TableCell, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { bg } from '../../../utils/darkModeAdapter';
import CardItem from './CardItem';
import AdviceContentBox from '../../../components/AdviceContentBox';


/**
 * 推奨採用人数と必要応募者数 (編集不可)
 */
export default function RecommendedHiresCard({ data, adv }) {
  const theme = useTheme();
  return (
    <CardItem
      title="推奨採用人数と必要な応募者数"
      adviceContent={<AdviceContentBox adviceObj={adv.recommendedHiresAndApplicants} />}
    >
      {!data || !data.recommendedHires || !data.requiredApplicants ? (
        <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
          未設定
        </Typography>
      ) : (
        <Box>
          <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
            <TableBody>
              <TableRow sx={{ backgroundColor: bg(theme).subtle, '& td': { border: 'none', px: 2 } }}>
                <TableCell>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    推奨採用人数:
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{data.recommendedHires} 人</Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ backgroundColor: bg(theme).subtle, '& td': { border: 'none', px: 2 } }}>
                <TableCell>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    必要応募者数:
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{data.requiredApplicants} 人</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      )}
    </CardItem>
  );
}